import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

export const RegisterIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      {/* Silhouette arrière (menthe aplat) */}
      <circle cx="16" cy="8" r="3" fill="var(--equiply-icon-bg)" />
      <path
        d="M11 19c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5"
        fill="var(--equiply-icon-bg)"
      />
      {/* Silhouette avant (bleu trait) */}
      <circle cx="9" cy="9" r="3.25" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" fill="hsl(var(--background))" />
      <path
        d="M3 20c0-3 2.7-5.25 6-5.25s6 2.25 6 5.25"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" fill="hsl(var(--background))"
      />
    </svg>
  ),
);
RegisterIcon.displayName = "RegisterIcon";
